var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E3D601C6-1586-4503-A027-2D8B952E2449") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meu-perfil_Ajuda",
    transform: "translate(-981.000000, -292.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)",
    transform: "translate(981.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.8 L14.8,2 C15,1.8 15,1.6 15,1.4 C15,1.2 14.9,1 14.8,0.8 L14.3,0.3 C14,1.33226763e-15 13.5,1.33226763e-15 13.1,0.3 L7.6,6 L1.9,0.2 C1.8,0.1 1.6,0 1.4,0 C1.1,0 0.9,0.1 0.8,0.2 L0.3,0.7 C0.1,0.9 0.1,1.1 0.1,1.3 C0.1,1.5 0.2,1.7 0.3,1.9 L7,8.8 C7.1,8.9 7.3,9 7.6,9 C7.8,9 8,8.9 8.1,8.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.8 L14.8,2 C15,1.8 15,1.6 15,1.4 C15,1.2 14.9,1 14.8,0.8 L14.3,0.3 C14,1.33226763e-15 13.5,1.33226763e-15 13.1,0.3 L7.6,6 L1.9,0.2 C1.8,0.1 1.6,0 1.4,0 C1.1,0 0.9,0.1 0.8,0.2 L0.3,0.7 C0.1,0.9 0.1,1.1 0.1,1.3 C0.1,1.5 0.2,1.7 0.3,1.9 L7,8.8 C7.1,8.9 7.3,9 7.6,9 C7.8,9 8,8.9 8.1,8.8 Z",
    id: "Path_1_"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottom);
export default __webpack_public_path__ + "static/media/chevron-bottom.acf881c8e2429cbe6af4ec61ab5e55b6.svg";
export { ForwardRef as ReactComponent };